// 客服4菜单
const menus = [
  {
    icon: 'el-icon-lx-home',
    index: '/simpleIndex',
    title: '系统首页',
  },
  {
    icon: 'el-icon-s-order',
    index: '3',
    title: '订单管理',
    subs: [
      {
        index: '/orderList',
        title: '订单管理',
      },
      {
        index: '/settlementOrderList',
        title: '结算列表',
      },
    ]
  },
  
]

export default menus
